import service from "./axiosConfig";

// 获取验证码
export const getCaptcha = () => {
  return service.get("/captchaImage");
};

// 用户注册
export const registerUser = (data) => {
  return service.post("/interface/userregister", data);
};

// 用户登录
export const login = (data) => {
  return service.post("/interface/sms/login", data);
};
